import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a6 6 0 0 1 6 -6h6a6 6 0 0 1 6 6a6 6 0 0 1 -6 6h-6a6 6 0 0 1 -6 -6","key":"svg-0"}]]

const IconCapsuleHorizontal = createReactComponent('outline', 'capsule-horizontal', 'CapsuleHorizontal', __iconNode);

export default IconCapsuleHorizontal;